export default __webpack_public_path__ + "static/media/firefighting.9aabc074.png";